import React from 'react';
import { observable, action } from 'mobx';
import { inject, observer } from 'mobx-react';

import { STORE_MAP } from '../../Store/MapStore';

@inject(stores => ({
    store: stores.store.get(STORE_MAP),
  }))
@observer
class MapArea extends React.Component {
    render() {
        const { type, area, store } = this.props
        const { scaled } = store
        const style = {
            width: scaled(area.Width),
            height: scaled(area.Height),
            top: scaled(area.Y),
            left: scaled(area.X)
        }
        let className = 'map__area' + (type ? ' ' + type : '')
        return <div
            className={className}
            style={style}
        >{area.Name}</div>
    }
}
export default MapArea